import { PlusCircleIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { humanReadableTime } from "../../utils/humanReadableFormat";

const Card = ({
  img,
  message,
  timestamp,
  onClick,
}: {
  img: string;
  message: string;
  timestamp: string;
  onClick: React.MouseEventHandler;
}) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="cursor-pointer"
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="flex flex-col justify-between relative w-64 h-80 rounded-3xl overflow-hidden">
        {img ? (
          <img
            draggable="false"
            src={img}
            className="absolute w-full h-full object-cover"
          />
        ) : message ? (
          <div className="absolute w-full h-full bg-gradient-to-b from-gray-800 to-black p-6 flex items-center justify-center">
            <p className="text-white text-lg font-medium line-clamp-6 text-center">
              {message}
            </p>
          </div>
        ) : (
          <div className="absolute w-full h-full bg-gray-200 flex items-center justify-center">
            <p className="text-gray-500">No content available</p>
          </div>
        )}
        <div
          className={`flex flex-row items-center h-11 rounded-3xl justify-between
            bg-black bg-opacity-30 `}
        ></div>
        {hover && (
          <div className="flex flex-row justify-center items-center rounded-3xl bg-black bg-opacity-30 backdrop-blur-sm h-14">
            Posted: {humanReadableTime(timestamp)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
